module.exports = __webpack_public_path__ + "img/ccompany-honor-VOC-20241218.ac4e886f.jpg";